module.exports = __webpack_public_path__ + "img/address.c52f71da.svg";